// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","preloader-rotate":"Spinner_preloader-rotate__jeaQn"};